import { ArrowUpRight, Phone } from "@phosphor-icons/react";
import { MaskLine, Reveal } from "@/components/site/Reveal";
import { useContent } from "@/context/ContentContext";

const PHOTO = "/doctor.jpg";
const trust = ["Pharmacology", "SGRR Medical College & Hospital", "Dehradun", "Patient-focused care"];

export function Hero() {
  const { content } = useContent();
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" className="relative pt-36 md:pt-44 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-16 items-center">
          {/* Left — copy */}
          <div className="lg:col-span-7">
            <Reveal delay={0.02}>
              <span className="label inline-flex items-center gap-2">
                <span className="w-6 h-px bg-[#14B8A6]" /> {content.hero.eyebrow}
              </span>
            </Reveal>

            <h1 className="font-display text-[2.75rem] leading-[1.03] sm:text-6xl lg:text-[4.5rem] mt-6 text-[#0B1B2B]">
              <MaskLine delay={0.05}>Trusted Medical</MaskLine>
              <MaskLine delay={0.1}>Care, with a</MaskLine>
              <MaskLine delay={0.15}><span className="text-[#0D9488]">Human</span> Approach.</MaskLine>
            </h1>

            <Reveal delay={0.14} className="mt-8 max-w-xl">
              <p className="text-lg text-[#4A5A6A]">{content.hero.sub}</p>
            </Reveal>

            <Reveal delay={0.18} className="mt-10 flex flex-wrap items-center gap-4">
              <button
                onClick={() => go("appointment")}
                data-testid="hero-book-cta"
                className="btn-accent inline-flex items-center gap-2 rounded-full pl-7 pr-6 py-4 font-semibold transition-[transform,background-color] duration-300"
              >
                Book an Appointment <ArrowUpRight size={18} weight="bold" />
              </button>
              <button
                onClick={() => go("contact")}
                data-testid="hero-contact-cta"
                className="btn-outline inline-flex items-center gap-2 rounded-full px-6 py-4 font-medium transition-[transform,border-color,color] duration-300"
              >
                <Phone size={18} weight="bold" /> Contact the Clinic
              </button>
            </Reveal>
          </div>

          {/* Right — photo */}
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -top-5 -right-5 w-2/3 h-2/3 bg-[#F4F7FA] rounded-3xl -z-10" />
              <div className="absolute -bottom-6 -left-6 w-24 h-24 rounded-2xl bg-[#0D9488] -z-10 hidden sm:block" />
              <div className="relative rounded-[1.75rem] overflow-hidden shadow-[0_40px_80px_-32px_rgba(11,27,43,0.4)] aspect-[4/5]">
                <img
                  src={PHOTO}
                  alt="Dr. Sangeeta Roy, Department of Pharmacology, SGRR Medical College and Hospital, Dehradun"
                  className="w-full h-full object-cover object-top"
                  loading="eager"
                />
              </div>
              <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 sm:left-6 sm:translate-x-0 bg-white rounded-2xl px-6 py-4 shadow-[0_20px_44px_-20px_rgba(11,27,43,0.35)] whitespace-nowrap">
                <span className="label text-[0.55rem]">Faculty</span>
                <p className="font-display text-lg text-[#0B1B2B] leading-tight mt-0.5">Dr. Sangeeta Roy</p>
                <p className="text-sm text-[#4A5A6A]">Department of Pharmacology</p>
              </div>
            </div>
          </div>
        </div>

        {/* Trust indicators — no boxes, clean row */}
        <Reveal delay={0.2} className="mt-24 md:mt-32 border-t border-[#E6EBF0] pt-10">
          <ul className="grid grid-cols-2 md:grid-cols-4 gap-8" data-testid="trust-indicators">
            {trust.map((t, i) => (
              <li key={t}>
                <span className="font-mono text-xs text-[#0D9488]">0{i + 1}</span>
                <p className="text-base text-[#0B1B2B] font-medium mt-1.5">{t}</p>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
